import React from "react";
import { FolderModelProviderModule } from "~/features";

export const AdvancedContentOrganisation = () => {
    return <FolderModelProviderModule />;
};
